import { API } from "../../../utils/api";

export async function getInsuranceAPI(modelType) {
  return (await API.get(`lease/insurance?modelType=${modelType}`)).data
}